import BaseService from "service/base";
import {
  GetPmpMonitoringReportUploadResultParams,
  GetPmpMonitoringReportUploadResultResponse,
  UploadPmpMonitoringReportParams,
  UploadPmpMonitoringReportResponse,
} from "./types";

class ReportCenterService extends BaseService {
  uploadPmpMonitoringReport = (
    params: UploadPmpMonitoringReportParams
  ): Promise<UploadPmpMonitoringReportResponse> => {
    const formData = new FormData();
    formData.append("metric", params.metric);
    formData.append("auditingPeriod", params.auditingPeriod);
    formData.append("formFile", params.file);
    formData.append("operatorId", params.userId);

    return this.sendExternalRequest(
      "uploadPmpMonitoringReport",
      formData,
      undefined,
      undefined,
      undefined,
      true
    ) as Promise<UploadPmpMonitoringReportResponse>;
  };

  getPmpMonitoringReportUploadResult = (
    params: GetPmpMonitoringReportUploadResultParams
  ): Promise<GetPmpMonitoringReportUploadResultResponse> => {
    return this.sendExternalRequest(
      "getPmpMonitoringReportUploadResult",
      params
    ) as Promise<GetPmpMonitoringReportUploadResultResponse>;
  };
}

const reportCenterService = new ReportCenterService();

export default reportCenterService;
